import './App.css';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { useState, useEffect } from 'react';
import AddItem from './AddItem';
import Product from './Product_detail';
import Contact from './Contact';
import About from './About';
import ShopBox from './ShopBox';
import ConfirmationOrder from './ConfirmationOrder';
import Home from './Prosta';
import Header from './Header';
import Productss from './Productss';
import ScrollToTop from './ScrollToTop';
import axios from 'axios';

function App() {
  const [itemCount, setItemCount] = useState(0);
  const [numbe, setNumbe] = useState(false);
  const [selectedItId, setSelectetItId] = useState([]);
  const [successMessage, setSuccessMessage] = useState(false);
  const [quantities, setQuantities] = useState({});
  const [isOpen, setIsOpen] = useState(false);

  const [selectedType, setSelectedType] = useState('');
  const [filteredProducts, setFilteredProducts] = useState([]);
  const [socks, setSocks] = useState([]);
  const [loading, setLoading] = useState(true);

  // New state for cart items
  const [cartItems, setCartItems] = useState([]);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  // Update itemCount whenever cartItems changes
  useEffect(() => {
    setItemCount(calculateTotalQuantity());
  }, [cartItems]);

  // Pulse animation for cart icon
  useEffect(() => {
    if (itemCount > 0) {
      setNumbe(true);
      const timer = setTimeout(() => setNumbe(false), 2000);
      return () => clearTimeout(timer);
    } else {
      setNumbe(false);
    }
  }, [itemCount]);

  // Fetch products from the backend
  useEffect(() => {
    setLoading(true);
    axios.get('https://cottonlocalhost1365.onrender.com/api/items')
      .then(response => {
        setSocks(response.data);
        setFilteredProducts(response.data);
        setLoading(false);
      })
      .catch(error => {
        console.error('There was an error fetching the data!', error);
        setLoading(false);
      });
  }, []);

  const handleTypeChange = (type) => {
    setSelectedType(type);
    if (type) {
      const filtered = socks.filter(sock => sock.typeOfSock === type);
      setFilteredProducts(filtered);
    } else {
      setFilteredProducts(socks.slice(0, 100));
    }
  };

  // Calculate total quantity of items in the cart
  const calculateTotalQuantity = () => {
    return cartItems.reduce((total, item) => total + item.quantity, 0);
  };

  const handleItemSelection = (id) => {
    // Get the desired quantity from the quantities state
    const desiredQuantity = quantities[id] || 1;

    // Check if the desired quantity exceeds the maximum allowed (20)
    if (desiredQuantity > 20) {
      alert("You cannot add more than 20 of this item.");
      return;
    }

    // Update cartItems state
    setCartItems((prevCartItems) => {
      const existingItem = prevCartItems.find((item) => item.productId === id);
      if (existingItem) {
        return prevCartItems.map((item) =>
          item.productId === id
            ? { ...item, quantity: item.quantity + desiredQuantity } // Add the desired quantity
            : item
        );
      } else {
        return [...prevCartItems, { productId: id, quantity: desiredQuantity }]; // Add new item with the desired quantity
      }
    });

    // Show success message
    setSuccessMessage(true);
    setTimeout(() => {
      setSuccessMessage(false);
    }, 2000);
  };

  const handleDeleteItem = (itemId) => {
    // Update cartItems state
    setCartItems((prevCartItems) => {
      const updatedCartItems = prevCartItems
        .map((item) => {
          if (item.productId === itemId) {
            return { ...item, quantity: item.quantity - 1 }; // Decrease quantity by 1
          }
          return item;
        })
        .filter((item) => item.quantity > 0); // Remove the item if quantity is 0
      return updatedCartItems;
    });

    // Update quantities state
    setQuantities((prevQuantities) => {
      const newQuantities = { ...prevQuantities };
      if (newQuantities[itemId] > 1) {
        newQuantities[itemId] -= 1; // Decrease quantity by 1
      } else {
        delete newQuantities[itemId]; // Remove the item if quantity is 1
      }
      return newQuantities;
    });

    // Update selected item IDs
    setSelectetItId((prevIds) => {
      const index = prevIds.indexOf(itemId);
      if (index > -1) {
        const newIds = [...prevIds];
        newIds.splice(index, 1);
        return newIds;
      }
      return prevIds;
    });
  };

  return (
    <div className="lg:p-[60px] sm:p-[40px] h-full font-serif w-full bg-[#F5F5F5]">
      <Router>
        <div className="App">
          <Header
            isOpen={isOpen}
            toggleMenu={toggleMenu}
            calculateTotalQuantity={calculateTotalQuantity}
            numbe={numbe}
            successMessage={successMessage}
            handleTypeChange={handleTypeChange}
            itemCount={itemCount} // Pass itemCount
          />
          <ScrollToTop />
          <Routes>
            <Route path="/submit-order" element={<ConfirmationOrder />} />
            <Route
              path="/shop-box"
              element={
                <ShopBox
                  id={selectedItId}
                  deleteItem={handleDeleteItem}
                  length={calculateTotalQuantity}
                  quantities={quantities}
                  setQuantities={setQuantities}
                  cartItems={cartItems}
                  setCartItems={setCartItems}
                />
              }
            />
            <Route
              path="/products"
              element={
                <Productss
                  selectedType={selectedType}
                  loading={loading}
                  handleTypeChange={handleTypeChange}
                  teemka={handleItemSelection}
                  countt={calculateTotalQuantity}
                  filteredProducts={filteredProducts}
                  cartItems={cartItems}
                  setCartItems={setCartItems}
                  quantities={quantities}
                  setQuantities={setQuantities}
                />
              }
            />
            <Route path="/9905012000" element={<AddItem />} />
            <Route
              path="/products/:id"
              element={
                <Product
                  addItem={handleItemSelection}
                  countingg={calculateTotalQuantity}
                  types={filteredProducts}
                  cartItems={cartItems} // Pass cartItems
                  setCartItems={setCartItems} // Pass setCartItems
                  quantities={quantities} // Pass quantities
                  setQuantities={setQuantities} // Pass setQuantities
                />
              }
            />
            <Route path="/about" element={<About />} />
            <Route path='/' element={<Home handleTypeChange={handleTypeChange} />} />
          </Routes>
        </div>
      </Router>
      <Contact />
    </div>
  );
}

export default App;